import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HubUiModule, VisualAppearance } from '@atpco/hub-ui';
import { AuthService } from '../auth.service';

@Component({
  selector: 'rh-access-denied',
  standalone: true,
  imports: [CommonModule, HubUiModule],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  VisualAppearance = VisualAppearance;

  constructor(private authService: AuthService) { }

  logout(): void {
    this.authService.logout();
  }
}
